// extracted by mini-css-extract-plugin
module.exports = {"sitemap":"sitemap_sitemap__oXvWR"};